import React from 'react'
import media from '../../../../media';
import moment from 'moment';
import { Link } from 'react-router-dom';

const SellerProductTable = ({approvalList, approvalPagination}) => {
    return (
        <div className="table-responsive">
            <table className="table table-bordered m-0 border radius-remove all_domain_table">
                <thead className="text-white bg-gray-700">
                    <tr>
                        <th className="font-weight-bolder font-size-lg all_table_id_number">S.No.</th>
                        <th className="width">Request ID</th>
                        <th className="width">Product Image</th>
                        <th className="width">Seller</th>
                        <th className="width">Product</th>
                        <th className="width">Status</th>
                        <th className="width">Comments</th>
                        <th className="width">Created On</th>
                        <th className="action_small_table_column">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {approvalList?.length > 0 ? (
                        approvalList?.map((approval, index) => {
                            const {
                                requestId,
                                imageLink,
                                seller,
                                productDetails,
                                status,
                                comments,
                                createdDate,
                                productId,
                            } = approval;

                            const statusClass = {
                                REJECTED: "bg-danger",
                                PENDING: "bg-warning",
                                APPROVED: "bg-primary",
                            }[status] || "bg-primary";

                            return (
                                <tr key={requestId || index} className="greyBackground">
                                    <td>{index + 1 + approvalPagination?.paginationFilter?.offset * 10}</td>
                                    <td nowrap="nowrap">{requestId}</td>
                                    <td>
                                        <img
                                            src={imageLink || media.Default}
                                            alt=""
                                            className="max-w-70px"
                                        />
                                    </td>
                                    <td>
                                        <p className="m-0 mb-1">{seller?.name}</p>
                                        <p className="m-0 mb-1">{seller?.email}</p>
                                    </td>
                                    <td className="font-weight-bolder text-left" nowrap="nowrap">
                                        <p className="m-0 mb-1">{productDetails?.name}</p>
                                        <p className="m-0 mb-1">Brand : {productDetails?.brand}</p>
                                    </td>
                                    <td>
                                        <span className={`p-1 px-2 text-white rounded font-size-sm ${statusClass}`}>
                                            {status}
                                        </span>
                                    </td>
                                    <td>{comments}</td>
                                    <td>
                                        <span>
                                            {createdDate && moment(createdDate).format("DD/MM/YYYY")}
                                        </span>
                                        <span className="text-muted d-block">
                                            {createdDate && moment.utc(createdDate).local().format("hh:mm A")}
                                        </span>
                                    </td>
                                    <td>
                                        <Link
                                            to={`/sellerVerificationRequest/${productId}`}
                                            state= {{ id: productId }}
                                        >
                                            <i className="flaticon-eye icon-lg text-dark font-weight-bold text-hover-primary cursor-pointer"></i>
                                        </Link>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={12} className="text-center">
                                No Data Found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>

    )
}

export default SellerProductTable